// extracted by mini-css-extract-plugin
export default {"aboutpageMain":"AboutPage_aboutpageMain__zEAx1","articleAbout":"AboutPage_articleAbout__WHG95"};